module.exports = __webpack_public_path__ + "static/media/KozGoPro-Regular.ff40ca5f.otf";